export function getNumber(number: unknown) {
  return number === null || Number.isNaN(Number(number))
    ? undefined
    : Number(number);
}
